import request from 'services/axios';

export const getGrade = async (payload: string) => {
  const {data}: {data: IGetGradeQuestions[]} = await request.get(
    `/api/v2/market/grading?subproduct=${payload}`,
  );
  return data;
};

export const setGradeAnswer = async (payload: ISetGradePayload) => {
  const {data} = await request.post(`/api/v2/market/grading`, {
    ...payload,
  });
  return data;
};
